export const SEND_REQUEST_REORDER_EMAIL_FOR_SUPPLIER = 'SEND_REQUEST_REORDER_EMAIL_FOR_SUPPLIER';
